import React from "react";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { InfoCircle } from "react-bootstrap-icons";
import workspaceTheme from "../../../components/artwork-workspace/workspaceTheme.module.css";

type Props = {
  label: React.ReactNode;
  helpText?: React.ReactNode;
  tooltipId?: string;
  htmlFor?: string;
  ariaLabel?: string;
  labelClassName?: string;
  as?: "form-label" | "text";
};

export const EdmFieldLabel = ({
  label,
  helpText,
  tooltipId,
  htmlFor,
  ariaLabel,
  labelClassName,
  as = "form-label",
}: Props) => {
  const labelNode = as === "form-label"
    ? <Form.Label htmlFor={htmlFor} className={labelClassName || "mb-0"}>{label}</Form.Label>
    : <div className={labelClassName || "fw-semibold"}>{label}</div>;

  if (!helpText) {
    return labelNode;
  }

  return (
    <div className="d-flex align-items-center gap-2">
      {labelNode}
      <OverlayTrigger
        placement="top"
        trigger={["hover", "focus", "click"]}
        overlay={(
          <Tooltip id={tooltipId || `${String(ariaLabel || label)}-help`}>
            {helpText}
          </Tooltip>
        )}
      >
        <Button
          variant="link"
          type="button"
          className={`p-0 text-decoration-none d-inline-flex align-items-center ${workspaceTheme.workspaceLinkAction}`}
          aria-label={ariaLabel || `${String(label)} help`}
        >
          <InfoCircle size={14} />
        </Button>
      </OverlayTrigger>
    </div>
  );
};

export default EdmFieldLabel;
